module.exports = __webpack_public_path__ + "static/media/Pirate_Cove-2.e0d657a1.webp";